import AabAccordion from './AabAccordion';

customElements.define('aab-accordion', AabAccordion);
